import React, { ReactNode } from "react";

import { Box, makeStyles } from "@material-ui/core";

interface ModalProps {
  children: ReactNode;

  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      width: "100%",
      overflow: "hidden",

      backgroundColor: theme.palette.common.white,
      zIndex: theme.zIndex.modal,
    },
    wrapper: {
      position: "relative",
    },
  }),
  { name: "modal-styles" }
);

export default function ModalV2(props: ModalProps) {
  const classes = useStyles(props);
  // Props
  const { children, open } = props;

  return open ? (
    <Box className={classes.root}>
      <Box className={classes.wrapper}>{children}</Box>
    </Box>
  ) : (
    <></>
  );
}

ModalV2.defaultProps = {
  open: false,
};
